import { render, staticRenderFns } from "./ForgotPasswordCard.vue?vue&type=template&id=0fdc7fa3&scoped=true"
import script from "./ForgotPasswordCard.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordCard.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordCard.vue?vue&type=style&index=0&id=0fdc7fa3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdc7fa3",
  null
  
)

export default component.exports